import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ApplicationHeader from '@mysidewalk/react-applicationheader';

import {
  ROOT,
  CATALOG_ROOT,
  CHART_ROOT,
  SEEK_ROOT,
  SIDEKICK_ROOT,
} from '../urls';
import Organization from '../organizations/Organization';
import ApplicationContext from './ApplicationContext';

const contextType = ApplicationContext;

const propTypes = {
  navigate: PropTypes.func.isRequired,
};

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      organizationName: '',
      isLoadingOrganization: false,
    };
  }

  componentDidUpdate() {
    this.tryLoadingOrganizationName();
  }

  get isAuthenticated() {
    const { sessionManager } = this.context;
    return sessionManager.status.isAuthenticated;
  }

  tryLoadingOrganizationName() {
    const { sessionManager } = this.context;
    const { organizationName, isLoadingOrganization } = this.state;
    if (
      this.isAuthenticated
        && !organizationName
        && !isLoadingOrganization
    ) {
      const { permissionManager } = sessionManager;
      this.setState({ isLoadingOrganization: true });
      const organizationID = permissionManager.getCurrentOrganizationID();
      Organization.retrieve(organizationID)
        .then((organization) => {
          this.setState({ organizationName: organization.name, isLoadingOrganization: false });
        })
        .catch(() => {
          this.setState({ isLoadingOrganization: false });
        });
    } else if (
      !this.isAuthenticated
        && organizationName
        && !isLoadingOrganization
    ) {
      this.setState({ organizationName: '', isLoadingOrganization: false });
    }
  }

  render() {
    const { sessionManager } = this.context;
    const { navigate } = this.props;
    const { organizationName } = this.state;

    const { permissionManager, user } = sessionManager;
    const { ProductType } = permissionManager;

    const access = {
      hasAuthenticatedAccess: sessionManager.status.isAuthenticated,
      hasStaffAccess: user?.isSuperuser ?? false,
      hasSeekAccess: permissionManager.canAccessProduct(ProductType.SEEK),
      hasChartAccess: permissionManager.canAccessProduct(ProductType.CHART),
      hasSidekickAccess: permissionManager.canAccessProduct(ProductType.SIDEKICK),
      hasWhereHouseAccess: permissionManager.canAccessProduct(ProductType.WHEREHOUSE),
    };

    const domains = {
      catalog: CATALOG_ROOT,
      chart: CHART_ROOT,
      seek: SEEK_ROOT,
      sidekick: SIDEKICK_ROOT,
      root: ROOT,
    };

    const onClickLink = (event) => {
      const href = event.currentTarget?.href;
      if (href.startsWith(domains.catalog)) {
        event.preventDefault();
        navigate(href.replace(domains.catalog, ''));
      }
    };

    const linkOverrides = {
      'data-upload': `${domains.sidekick}/data/uploads/new`,
    };

    return (
      <div style={{ position: 'fixed', width: '100%', zIndex: 10000 }}>
        <ApplicationHeader
          productName="Catalog"
          organizationName={organizationName}
          user={sessionManager.user}
          links={linkOverrides}
          access={access}
          domains={domains}
          onClickLink={onClickLink}
        />
      </div>
    );
  }
}

Header.contextType = contextType;
Header.propTypes = propTypes;

function withNavigate(Comp) {
  return function HeaderWithNavigate() {
    return (
      <Comp navigate={useNavigate()} />
    );
  };
}

export default withNavigate(Header);
